import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCustomerConversationsAnalyticsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'customer-service-helpcenter-customer-conversations-analytics',
	path: '/jira/helpcenter/customer-conversations-analytics',
};
